/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomerUserInvitationResendResult {
  Success = 0,
  Error = 1,
  InvitationNotFound = 2,
  InvitationCompleted = 3,
  InvitationNotExpired = 4,
  EmailSendingFailed = 5,
  InvalidCompany = 6,
}
